import dayjs from "dayjs";

import { CumulativeRoiData } from "../services/cumulative-roi";

type Props = {
  data?: CumulativeRoiData[];
  firstDate: dayjs.Dayjs;
};

export const getBacktestRoiData = ({
  data = [],
  firstDate,
}: Props): uPlot.AlignedData => {
  const slicedData = data.filter(
    ({ date }) => firstDate.isSame(date) || firstDate.isBefore(date)
  );

  const [dates, values]: [number[], number[]] = [[], []];
  for (const { date, value } of slicedData) {
    if (!date || !value) continue;
    dates.push(dayjs(date).unix());
    values.push(+value?.toFixed(2));
  }
  return [dates, values];
};
